import React from "react";
import colors, { colorsV2 } from "../../styles/colors";
import { connect } from "react-redux";

const TimerDisplay = (props) => {
  
  const getMinRemainingInSegment = () => {
    const mins = Math.floor(props.userActivity.totalTime / 1000 / 60) % 60;
    return 20 - (mins % 20);
  };

  const getSegmentsComplete = () => {
    const mins = Math.floor(props.userActivity.totalTime / 1000 / 60);
    return Math.floor(mins / 20);
  };

  const formatTime = (time) => {
    const secs = Math.floor(time / 1000) % 60;
    const mins = Math.floor(time / 1000 / 60) % 60;
    const hrs = Math.floor(time / 1000 / 60 / 60);
    return `${hrs}:${mins}:${secs}`;
  };

  return (
    <div>
      {props.userActivity.shouldTrackTimeInChart && (
        <div
          style={{
            borderRadius: 9,
            borderColor: colorsV2.lightningYellow,
            borderWidth: 4,
            borderStyle: "solid",
            margin: 5,
            padding: 10,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-evenly",
            alignContent: "center",
            width: 500,
          }}
        >
          <div>
            <span
              style={{ color: colors.primary, fontSize: 18, fontWeight: "800" }}
            >
              {getMinRemainingInSegment()} Min. Remaining
            </span>
          </div>
          <div style={{ flexDirection: "column" }}>
            <span style={{ fontSize: 12, color: colors.primary }}>
              Care Segments Complete
            </span>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
              }}
            >
              <div
                style={{
                  height: 15,
                  width: 15,
                  backgroundColor:
                    getSegmentsComplete() >= 1 ? "orange" : "grey",
                  margin: 3,
                }}
              ></div>
              <div
                style={{
                  height: 15,
                  width: 15,
                  backgroundColor:
                    getSegmentsComplete() >= 2 ? "orange" : "grey",
                  margin: 3,
                }}
              ></div>
              <div
                style={{
                  height: 15,
                  width: 15,
                  backgroundColor:
                    getSegmentsComplete() >= 3 ? "orange" : "grey",
                  margin: 3,
                }}
              ></div>
              <div
                style={{
                  height: 15,
                  width: 15,
                  backgroundColor:
                    getSegmentsComplete() >= 4 ? "orange" : "grey",
                  margin: 3,
                }}
              ></div>
              <div
                style={{
                  height: 15,
                  width: 15,
                  backgroundColor:
                    getSegmentsComplete() >= 5 ? "orange" : "grey",
                  margin: 3,
                }}
              ></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({});

const mapStateToProps = ({ userActivity }, props) => ({
  userActivity,
  props,
});

export default connect(mapStateToProps, mapDispatchToProps)(TimerDisplay);



// WEBPACK FOOTER //
// ./src/components/rtm/TimerDisplay.js